import type { CSSProperties, Ref } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import type { PromptSide } from './hooks/usePromptPosition'

export const PROMPT_TAIL_SIZE = 7

// Drawn pointing up from the card's top edge, and turned over onto its bottom edge when the card sits above its anchor.
const Tail = styled.span`
  position: absolute;
  inline-size: ${rem(PROMPT_TAIL_SIZE * 2)};
  block-size: ${rem(PROMPT_TAIL_SIZE)};

  &.bottom {
    inset-block-end: 100%;
  }

  &.top {
    inset-block-start: 100%;
    rotate: 180deg;
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
    inset-inline-start: 0;
    border-inline: ${rem(PROMPT_TAIL_SIZE)} solid transparent;
    border-block-end: ${rem(PROMPT_TAIL_SIZE)} solid;
  }

  &::before {
    inset-block-end: 0;
    border-block-end-color: ${props => props.theme.palette.neutral.surface.lightForeground};
  }

  /* Overlaps the card's border so the tail reads as part of the card. */
  &::after {
    inset-block-end: ${rem(-1)};
    border-block-end-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  }
`

interface Props {
  ref: Ref<HTMLSpanElement>
  /** The card's side of its anchor; the tail points back at the anchor */
  side: PromptSide
  style: CSSProperties
}

function PromptTail({ ref, side, style }: Props) {
  return <Tail ref={ref} style={style} className={side} />
}

export default PromptTail
